/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as ApprovalsRouteImport } from './routes/approvals'
import { Route as AutomationRouteImport } from './routes/automation'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as MyActivityRouteImport } from './routes/my-activity'
import { Route as NewRouteImport } from './routes/new'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as StatusRouteImport } from './routes/status'
import { Route as TodosRouteImport } from './routes/todos'
import { Route as KbIndexRouteImport } from './routes/kb.index'
import { Route as KbManageRouteImport } from './routes/kb.manage'
import { Route as PeopleIndexRouteImport } from './routes/people.index'
import { Route as PeopleIdRouteImport } from './routes/people.$id'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsAppUsageRouteImport } from './routes/reports.app-usage'
import { Route as ReportsAutomationRouteImport } from './routes/reports.automation'
import { Route as ReportsDeflectionRouteImport } from './routes/reports.deflection'
import { Route as ReportsNotificationsRouteImport } from './routes/reports.notifications'
import { Route as ReportsRequestActivityRouteImport } from './routes/reports.request-activity'
import { Route as ReportsSatisfactionRouteImport } from './routes/reports.satisfaction'
import { Route as ReportsSecurityRouteImport } from './routes/reports.security'
import { Route as ReportsUsersWithoutSiteRouteImport } from './routes/reports.users-without-site'
import { Route as TicketsIndexRouteImport } from './routes/tickets.index'
import { Route as TicketsIdRouteImport } from './routes/tickets.$id'
import { Route as KbCollectionIndexRouteImport } from './routes/kb.$collection.index'
import { Route as KbCollectionSlugRouteImport } from './routes/kb.$collection.$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsRoute = ApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationRoute = AutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const MyActivityRoute = MyActivityRouteImport.update({
  id: '/my-activity',
  path: '/my-activity',
  getParentRoute: () => rootRouteImport,
} as any)
const NewRoute = NewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const TodosRoute = TodosRouteImport.update({
  id: '/todos',
  path: '/todos',
  getParentRoute: () => rootRouteImport,
} as any)
const KbIndexRoute = KbIndexRouteImport.update({
  id: '/kb/',
  path: '/kb/',
  getParentRoute: () => rootRouteImport,
} as any)
const KbManageRoute = KbManageRouteImport.update({
  id: '/kb/manage',
  path: '/kb/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIdRoute = PeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsAppUsageRoute = ReportsAppUsageRouteImport.update({
  id: '/reports/app-usage',
  path: '/reports/app-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsAutomationRoute = ReportsAutomationRouteImport.update({
  id: '/reports/automation',
  path: '/reports/automation',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsDeflectionRoute = ReportsDeflectionRouteImport.update({
  id: '/reports/deflection',
  path: '/reports/deflection',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsNotificationsRoute = ReportsNotificationsRouteImport.update({
  id: '/reports/notifications',
  path: '/reports/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRequestActivityRoute = ReportsRequestActivityRouteImport.update({
  id: '/reports/request-activity',
  path: '/reports/request-activity',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsSatisfactionRoute = ReportsSatisfactionRouteImport.update({
  id: '/reports/satisfaction',
  path: '/reports/satisfaction',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsSecurityRoute = ReportsSecurityRouteImport.update({
  id: '/reports/security',
  path: '/reports/security',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsUsersWithoutSiteRoute = ReportsUsersWithoutSiteRouteImport.update({
  id: '/reports/users-without-site',
  path: '/reports/users-without-site',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIdRoute = TicketsIdRouteImport.update({
  id: '/tickets/$id',
  path: '/tickets/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const KbCollectionIndexRoute = KbCollectionIndexRouteImport.update({
  id: '/kb/$collection/',
  path: '/kb/$collection/',
  getParentRoute: () => rootRouteImport,
} as any)
const KbCollectionSlugRoute = KbCollectionSlugRouteImport.update({
  id: '/kb/$collection/$slug',
  path: '/kb/$collection/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/analytics': typeof AnalyticsRoute
  '/approvals': typeof ApprovalsRoute
  '/automation': typeof AutomationRoute
  '/catalog': typeof CatalogRoute
  '/my-activity': typeof MyActivityRoute
  '/new': typeof NewRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/status': typeof StatusRoute
  '/todos': typeof TodosRoute
  '/kb/manage': typeof KbManageRoute
  '/people/$id': typeof PeopleIdRoute
  '/reports/app-usage': typeof ReportsAppUsageRoute
  '/reports/automation': typeof ReportsAutomationRoute
  '/reports/deflection': typeof ReportsDeflectionRoute
  '/reports/notifications': typeof ReportsNotificationsRoute
  '/reports/request-activity': typeof ReportsRequestActivityRoute
  '/reports/satisfaction': typeof ReportsSatisfactionRoute
  '/reports/security': typeof ReportsSecurityRoute
  '/reports/users-without-site': typeof ReportsUsersWithoutSiteRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/kb/': typeof KbIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/kb/$collection/$slug': typeof KbCollectionSlugRoute
  '/kb/$collection/': typeof KbCollectionIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/analytics': typeof AnalyticsRoute
  '/approvals': typeof ApprovalsRoute
  '/automation': typeof AutomationRoute
  '/catalog': typeof CatalogRoute
  '/my-activity': typeof MyActivityRoute
  '/new': typeof NewRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/status': typeof StatusRoute
  '/todos': typeof TodosRoute
  '/kb/manage': typeof KbManageRoute
  '/people/$id': typeof PeopleIdRoute
  '/reports/app-usage': typeof ReportsAppUsageRoute
  '/reports/automation': typeof ReportsAutomationRoute
  '/reports/deflection': typeof ReportsDeflectionRoute
  '/reports/notifications': typeof ReportsNotificationsRoute
  '/reports/request-activity': typeof ReportsRequestActivityRoute
  '/reports/satisfaction': typeof ReportsSatisfactionRoute
  '/reports/security': typeof ReportsSecurityRoute
  '/reports/users-without-site': typeof ReportsUsersWithoutSiteRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/kb': typeof KbIndexRoute
  '/people': typeof PeopleIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/tickets': typeof TicketsIndexRoute
  '/kb/$collection/$slug': typeof KbCollectionSlugRoute
  '/kb/$collection': typeof KbCollectionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/analytics': typeof AnalyticsRoute
  '/approvals': typeof ApprovalsRoute
  '/automation': typeof AutomationRoute
  '/catalog': typeof CatalogRoute
  '/my-activity': typeof MyActivityRoute
  '/new': typeof NewRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/status': typeof StatusRoute
  '/todos': typeof TodosRoute
  '/kb/manage': typeof KbManageRoute
  '/people/$id': typeof PeopleIdRoute
  '/reports/app-usage': typeof ReportsAppUsageRoute
  '/reports/automation': typeof ReportsAutomationRoute
  '/reports/deflection': typeof ReportsDeflectionRoute
  '/reports/notifications': typeof ReportsNotificationsRoute
  '/reports/request-activity': typeof ReportsRequestActivityRoute
  '/reports/satisfaction': typeof ReportsSatisfactionRoute
  '/reports/security': typeof ReportsSecurityRoute
  '/reports/users-without-site': typeof ReportsUsersWithoutSiteRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/kb/': typeof KbIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/kb/$collection/$slug': typeof KbCollectionSlugRoute
  '/kb/$collection/': typeof KbCollectionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/analytics'
    | '/approvals'
    | '/automation'
    | '/catalog'
    | '/my-activity'
    | '/new'
    | '/profile'
    | '/settings'
    | '/status'
    | '/todos'
    | '/kb/manage'
    | '/people/$id'
    | '/reports/app-usage'
    | '/reports/automation'
    | '/reports/deflection'
    | '/reports/notifications'
    | '/reports/request-activity'
    | '/reports/satisfaction'
    | '/reports/security'
    | '/reports/users-without-site'
    | '/tickets/$id'
    | '/kb/'
    | '/people/'
    | '/reports/'
    | '/tickets/'
    | '/kb/$collection/$slug'
    | '/kb/$collection/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/analytics'
    | '/approvals'
    | '/automation'
    | '/catalog'
    | '/my-activity'
    | '/new'
    | '/profile'
    | '/settings'
    | '/status'
    | '/todos'
    | '/kb/manage'
    | '/people/$id'
    | '/reports/app-usage'
    | '/reports/automation'
    | '/reports/deflection'
    | '/reports/notifications'
    | '/reports/request-activity'
    | '/reports/satisfaction'
    | '/reports/security'
    | '/reports/users-without-site'
    | '/tickets/$id'
    | '/kb'
    | '/people'
    | '/reports'
    | '/tickets'
    | '/kb/$collection/$slug'
    | '/kb/$collection'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/analytics'
    | '/approvals'
    | '/automation'
    | '/catalog'
    | '/my-activity'
    | '/new'
    | '/profile'
    | '/settings'
    | '/status'
    | '/todos'
    | '/kb/manage'
    | '/people/$id'
    | '/reports/app-usage'
    | '/reports/automation'
    | '/reports/deflection'
    | '/reports/notifications'
    | '/reports/request-activity'
    | '/reports/satisfaction'
    | '/reports/security'
    | '/reports/users-without-site'
    | '/tickets/$id'
    | '/kb/'
    | '/people/'
    | '/reports/'
    | '/tickets/'
    | '/kb/$collection/$slug'
    | '/kb/$collection/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AnalyticsRoute: typeof AnalyticsRoute
  ApprovalsRoute: typeof ApprovalsRoute
  AutomationRoute: typeof AutomationRoute
  CatalogRoute: typeof CatalogRoute
  MyActivityRoute: typeof MyActivityRoute
  NewRoute: typeof NewRoute
  ProfileRoute: typeof ProfileRoute
  SettingsRoute: typeof SettingsRoute
  StatusRoute: typeof StatusRoute
  TodosRoute: typeof TodosRoute
  KbManageRoute: typeof KbManageRoute
  PeopleIdRoute: typeof PeopleIdRoute
  ReportsAppUsageRoute: typeof ReportsAppUsageRoute
  ReportsAutomationRoute: typeof ReportsAutomationRoute
  ReportsDeflectionRoute: typeof ReportsDeflectionRoute
  ReportsNotificationsRoute: typeof ReportsNotificationsRoute
  ReportsRequestActivityRoute: typeof ReportsRequestActivityRoute
  ReportsSatisfactionRoute: typeof ReportsSatisfactionRoute
  ReportsSecurityRoute: typeof ReportsSecurityRoute
  ReportsUsersWithoutSiteRoute: typeof ReportsUsersWithoutSiteRoute
  TicketsIdRoute: typeof TicketsIdRoute
  KbIndexRoute: typeof KbIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
  KbCollectionSlugRoute: typeof KbCollectionSlugRoute
  KbCollectionIndexRoute: typeof KbCollectionIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals': {
      id: '/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automation': {
      id: '/automation'
      path: '/automation'
      fullPath: '/automation'
      preLoaderRoute: typeof AutomationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-activity': {
      id: '/my-activity'
      path: '/my-activity'
      fullPath: '/my-activity'
      preLoaderRoute: typeof MyActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/todos': {
      id: '/todos'
      path: '/todos'
      fullPath: '/todos'
      preLoaderRoute: typeof TodosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb/': {
      id: '/kb/'
      path: '/kb'
      fullPath: '/kb/'
      preLoaderRoute: typeof KbIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb/manage': {
      id: '/kb/manage'
      path: '/kb/manage'
      fullPath: '/kb/manage'
      preLoaderRoute: typeof KbManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$id': {
      id: '/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof PeopleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/app-usage': {
      id: '/reports/app-usage'
      path: '/reports/app-usage'
      fullPath: '/reports/app-usage'
      preLoaderRoute: typeof ReportsAppUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/automation': {
      id: '/reports/automation'
      path: '/reports/automation'
      fullPath: '/reports/automation'
      preLoaderRoute: typeof ReportsAutomationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/deflection': {
      id: '/reports/deflection'
      path: '/reports/deflection'
      fullPath: '/reports/deflection'
      preLoaderRoute: typeof ReportsDeflectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/notifications': {
      id: '/reports/notifications'
      path: '/reports/notifications'
      fullPath: '/reports/notifications'
      preLoaderRoute: typeof ReportsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/request-activity': {
      id: '/reports/request-activity'
      path: '/reports/request-activity'
      fullPath: '/reports/request-activity'
      preLoaderRoute: typeof ReportsRequestActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/satisfaction': {
      id: '/reports/satisfaction'
      path: '/reports/satisfaction'
      fullPath: '/reports/satisfaction'
      preLoaderRoute: typeof ReportsSatisfactionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/security': {
      id: '/reports/security'
      path: '/reports/security'
      fullPath: '/reports/security'
      preLoaderRoute: typeof ReportsSecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/users-without-site': {
      id: '/reports/users-without-site'
      path: '/reports/users-without-site'
      fullPath: '/reports/users-without-site'
      preLoaderRoute: typeof ReportsUsersWithoutSiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$id': {
      id: '/tickets/$id'
      path: '/tickets/$id'
      fullPath: '/tickets/$id'
      preLoaderRoute: typeof TicketsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb/$collection/': {
      id: '/kb/$collection/'
      path: '/kb/$collection'
      fullPath: '/kb/$collection/'
      preLoaderRoute: typeof KbCollectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb/$collection/$slug': {
      id: '/kb/$collection/$slug'
      path: '/kb/$collection/$slug'
      fullPath: '/kb/$collection/$slug'
      preLoaderRoute: typeof KbCollectionSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AnalyticsRoute: AnalyticsRoute,
  ApprovalsRoute: ApprovalsRoute,
  AutomationRoute: AutomationRoute,
  CatalogRoute: CatalogRoute,
  MyActivityRoute: MyActivityRoute,
  NewRoute: NewRoute,
  ProfileRoute: ProfileRoute,
  SettingsRoute: SettingsRoute,
  StatusRoute: StatusRoute,
  TodosRoute: TodosRoute,
  KbManageRoute: KbManageRoute,
  PeopleIdRoute: PeopleIdRoute,
  ReportsAppUsageRoute: ReportsAppUsageRoute,
  ReportsAutomationRoute: ReportsAutomationRoute,
  ReportsDeflectionRoute: ReportsDeflectionRoute,
  ReportsNotificationsRoute: ReportsNotificationsRoute,
  ReportsRequestActivityRoute: ReportsRequestActivityRoute,
  ReportsSatisfactionRoute: ReportsSatisfactionRoute,
  ReportsSecurityRoute: ReportsSecurityRoute,
  ReportsUsersWithoutSiteRoute: ReportsUsersWithoutSiteRoute,
  TicketsIdRoute: TicketsIdRoute,
  KbIndexRoute: KbIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  TicketsIndexRoute: TicketsIndexRoute,
  KbCollectionSlugRoute: KbCollectionSlugRoute,
  KbCollectionIndexRoute: KbCollectionIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
